var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimpleRepayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2334 3H0V48.4922H46C46.2078 46.1608 45.2821 46.5898 47 45C48.7179 43.4102 45.8593 42.4268 48.1998 42.4L48.2334 3Z",
    fill: "#7256CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0078 30.2441V67.7479L54.7746 64.0109H54.9423H55.099L88.8769 67.7479V30.2441L55.1214 34.5069H54.9423H54.7522L21.0078 30.2441Z",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9438 58.081C59.8316 58.081 63.7939 54.1187 63.7939 49.2309C63.7939 44.3432 59.8316 40.3809 54.9438 40.3809C50.0561 40.3809 46.0938 44.3432 46.0938 49.2309C46.0938 54.1187 50.0561 58.081 54.9438 58.081Z",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0775 26.6076V3M46.5742 18.0037L55.0775 26.6076L46.5742 18.0037ZM55.0775 26.6076L63.7821 18.0037L55.0775 26.6076Z",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2896 69.3926V93.0003M63.7928 77.9854L55.2896 69.3926L63.7928 77.9854ZM55.2896 69.3926L46.585 77.9854L55.2896 69.3926Z",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.709 77.9965L55.3129 69.3926L63.8497 77.9294",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6593 18.0596L55.0554 26.6635L46.5186 18.1267",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleRepayment);
export default __webpack_public_path__ + "static/media/simple_repayment.b46eb9642ba16bcef2cae1ccda2fd644.svg";
export { ForwardRef as ReactComponent };